import { render, staticRenderFns } from "./p06.vue?vue&type=template&id=4ad3a4a4&scoped=true&"
import script from "./p06.vue?vue&type=script&lang=js&"
export * from "./p06.vue?vue&type=script&lang=js&"
import style0 from "./p06.vue?vue&type=style&index=0&id=4ad3a4a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3a4a4",
  null
  
)

export default component.exports